import React, { useState } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { useDeliveryDays, useRoutePlanSetups } from './apiHooks';
import Loader from '../../components/loader';
import ErrorMessage from '../../components/errorMessage';
import utils from '../../utils/utils';
import Select from 'react-select';
import DATE_FORMAT from '../../components/constants/dateFormat';
import AdminRoutePlanV2RouteSetupDisplay from './adminRoutePlanV2RouteSetupDisplay';

const AdminRoutePlanV2SetupsDeliveryDaysModal = ({ onSuccess }) => {
  const [selectedDeliveryDay, setSelectedDeliveryDay] = useState(null);

  const { isLoading: loading, deliveryDays } = useDeliveryDays({
    showAll: true,
    sortBy: 'deliveryDateDesc',
    max: 20,
  });

  const {
    isLoading: isRoutePlanSetupsLoading,
    isError: isRoutePlanSetupsError,
    error: routePlanSetupsError,
    routePlanSetups,
  } = useRoutePlanSetups({
    deliveryDayId: selectedDeliveryDay?.id,
  });

  const selectedDeliveryDayOption = selectedDeliveryDay
    ? {
        value: selectedDeliveryDay,
        label: `${utils.getFormattedDateFromString(
          selectedDeliveryDay.deliveryDate,
          DATE_FORMAT.displayWeekdayAndDate
        )}`,
      }
    : null;

  return (
    <div className="admin__route-plan-setups-delivery-days">
      <h2>
        <FormattedMessage id={'admin.route.plan.setups.delivery.days.modal.header'} />
      </h2>

      <Loader show={loading || isRoutePlanSetupsLoading} />
      {isRoutePlanSetupsError ? <ErrorMessage error={utils.getErrorMessageFromResponse(routePlanSetupsError)} /> : ''}

      {deliveryDays ? (
        <div className="form-group m-b-6">
          <label htmlFor="ddSelect">
            <FormattedMessage id={'admin.route.plan.setups.delivery.days.modal.header.delivery.day.label'} />
          </label>
          <Select
            name="ddSelect"
            value={selectedDeliveryDayOption}
            onChange={(option) => setSelectedDeliveryDay(option.value, true)}
            options={deliveryDays.map((deliveryDay) => ({
              value: deliveryDay,
              label: `${utils.getFormattedDateFromString(deliveryDay.deliveryDate, DATE_FORMAT.displayWeekdayAndDate)}`,
            }))}
          />
        </div>
      ) : (
        ''
      )}

      <div className="m-b-6">
        {routePlanSetups
          ? routePlanSetups.map((rps) => <AdminRoutePlanV2RouteSetupDisplay routePlanSetup={rps} />)
          : ''}
      </div>

      <div className="text-center">
        <button className="btn btn-primary" onClick={() => onSuccess(routePlanSetups)} disabled={!selectedDeliveryDay}>
          <FormattedMessage id={'admin.route.plan.setups.delivery.days.modal.cta'} />
        </button>
      </div>
    </div>
  );
};

export default injectIntl(AdminRoutePlanV2SetupsDeliveryDaysModal);
